export var version = '10.1.1'; // Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.